import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="px-4 py-6 text-center text-sm leading-relaxed text-faint border-t border-line mt-8">
      <p className="mb-2">
        {t('footer.disclaimer')}
      </p>
      <p className="mb-2">
        <Trans
          i18nKey="footer.crawler"
          components={{
            crawlerLink: (
              <a
                href="https://github.com/senko/cijene-api"
                target="_blank"
                rel="noopener noreferrer"
                className="text-faint hover:text-muted underline underline-offset-2"
              />
            ),
          }}
        />
      </p>
      <p className="mb-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        <Link to="/privatnost" className="text-faint hover:text-muted underline underline-offset-2">{t('footer.privacy')}</Link>
        <span aria-hidden="true">·</span>
        <Link to="/uvjeti" className="text-faint hover:text-muted underline underline-offset-2">{t('footer.terms')}</Link>
      </p>
      <p>
        {t('footer.builtBy')}{' '}
        <a href="https://infinapps.com" target="_blank" rel="noopener noreferrer" className="text-faint hover:text-muted underline underline-offset-2">
          Infinapps
        </a>
      </p>
    </footer>
  )
}
